(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-photo-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => scope.querySelectorAll('[data-customer-gallery]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const photos = [...root.querySelectorAll('[data-gallery-photo]')];
    const dialog = root.querySelector('[data-gallery-dialog]');
    const large = root.querySelector('[data-gallery-large]');
    const caption = root.querySelector('[data-gallery-caption]');
    const close = root.querySelector('[data-gallery-close]');
    let index = 0, opener, overflow, touchX;
    const show = next => {
      index = (next + photos.length) % photos.length;
      const photo = photos[index];
      large.src = photo.dataset.fullImage;
      large.alt = photo.querySelector('img').alt;
      caption.replaceChildren(photo.closest('article').querySelector('[data-gallery-details]').cloneNode(true));
      root.querySelector('[data-gallery-position]').textContent = `${index + 1} / ${photos.length}`;
    };
    photos.forEach((photo, i) => photo.addEventListener('click', () => {
      opener = photo;
      show(i);
      overflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      close.focus();
    }));
    root.querySelectorAll('[data-gallery-prev],[data-gallery-next]').forEach(button => { button.hidden = photos.length < 2; });
    root.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
    root.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { document.body.style.overflow = overflow || ''; opener?.focus(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    const media = root.querySelector('.ew-customer-gallery__large-photo');
    media.addEventListener('touchstart', event => { touchX = event.touches[0].clientX; }, { passive: true });
    media.addEventListener('touchend', event => {
      if (touchX === undefined) return;
      const distance = event.changedTouches[0].clientX - touchX;
      if (Math.abs(distance) > 50) show(index + (distance < 0 ? 1 : -1));
      touchX = undefined;
    }, { passive: true });
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ethnicwish-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ethnicwish-reviews')) {
    customElements.define('ethnicwish-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) { this.load(1); return; }
        this.initialized = true;
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.form = this.querySelector('form');
        this.dialog = this.querySelector('.ew-review-dialog');
        this.viewer = this.querySelector('.ew-review-viewer');
        this.photoPages = new Map();
        this.bindViewer();
        this.previewUrls = [];
        this.querySelector('[data-write]').addEventListener('click', () => this.dialog.showModal());
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.querySelector('[data-write]').focus());
        this.form.addEventListener('input', () => this.updateInputs());
        this.form.elements.photos.addEventListener('change', () => this.previewPhotos());
        this.form.addEventListener('submit', event => this.submit(event));
        this.querySelector('[data-pages]').addEventListener('click', event => {
          const button = event.target.closest('button[data-page]');
          if (button) this.load(Number(button.dataset.page), true);
        });
        this.load(1);
      }
      disconnectedCallback() { this.controller?.abort(); this.dialog?.close(); this.viewer?.close(); this.photoController?.abort(); this.clearPreviews(); }
      bindViewer() {
        this.addEventListener('click', event => {
          const link = event.target.closest('a[data-review-photo]');
          if (!link) return;
          event.preventDefault(); this.photoTrigger = link;
          this.photoPage = Number(link.dataset.photoPage); this.photoIndex = Number(link.dataset.reviewPhoto);
          this.viewer.showModal(); this.showPhoto();
        });
        this.querySelector('[data-viewer-close]').addEventListener('click', () => this.viewer.close());
        this.querySelector('[data-photo-prev]').addEventListener('click', () => this.movePhoto(-1));
        this.querySelector('[data-photo-next]').addEventListener('click', () => this.movePhoto(1));
        this.viewer.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.movePhoto(event.key === 'ArrowRight' ? 1 : -1); }
        });
        this.viewer.addEventListener('close', () => { this.photoController?.abort(); this.photoTrigger?.focus(); });
        this.viewer.addEventListener('click', event => {
          const rect = this.viewer.getBoundingClientRect();
          if (event.target === this.viewer && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.viewer.close();
        });
        const media = this.querySelector('[data-viewer-image]');
        media.addEventListener('touchstart', event => { this.touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null; }, {passive:true});
        media.addEventListener('touchend', event => {
          if (!this.touchStart) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x, dy = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.movePhoto(dx < 0 ? 1 : -1);
        }, {passive:true});
      }
      collectPhotos(reviews) {
        const photos = [];
        for (const review of reviews) for (const photo of (review.photos || []).slice(0,3)) {
          let url; try { url = new URL(photo.url, location.origin); } catch { continue; }
          if (url.origin === location.origin && url.pathname.startsWith('/apps/ethnicwish-reviews/photos/')) photos.push({url:url.href,review});
        }
        return photos;
      }
      showPhoto() {
        const photos = this.photoPages.get(this.photoPage) || [], photo = photos[this.photoIndex];
        if (!photo) return;
        const img = this.querySelector('[data-viewer-image]'); img.src = photo.url;
        const copy = this.querySelector('[data-viewer-copy]'); copy.replaceChildren(this.stars(photo.review.rating));
        const person = this.node('div'); person.className = 'ew-review-person'; person.append(this.node('strong',photo.review.name)); copy.append(person);
        if (photo.review.verifiedPurchase === true) { const badge=this.node('span',`✓ ${this.labels.verified}`); badge.dataset.verified=''; copy.append(badge); }
        copy.append(this.node('p',photo.review.body));
        this.querySelector('[data-photo-position]').textContent = `${this.photoIndex+1} / ${photos.length}`;
        this.querySelector('[data-photo-prev]').disabled = this.photoPage === 1 && this.photoIndex === 0;
        this.querySelector('[data-photo-next]').disabled = this.photoPage >= this.lastPhotoPage && this.photoIndex === photos.length-1;
        this.querySelector('[data-viewer-error]').hidden = true;
      }
      async movePhoto(direction) {
        if (this.photoLoading || !this.viewer.open) return;
        const photos=this.photoPages.get(this.photoPage)||[], index=this.photoIndex+direction;
        if (index >= 0 && index < photos.length) { this.photoIndex=index; this.showPhoto(); return; }
        const page=this.photoPage+direction;
        if (page < 1 || page > this.lastPhotoPage) return;
        this.photoLoading=true; this.photoController=new AbortController();
        this.viewer.setAttribute('aria-busy','true');
        try {
          let next=this.photoPages.get(page);
          if (!next) {
            const url=new URL(this.dataset.endpoint,location.origin); url.searchParams.set('product_id',this.dataset.productId); url.searchParams.set('page',page);
            const response=await fetch(url,{signal:this.photoController.signal,headers:{Accept:'application/json'}});
            if (!response.ok) throw new Error('Unavailable');
            const data=await response.json();
            if (!Array.isArray(data.reviews) || data.page !== page) throw new Error('Invalid response');
            next=this.collectPhotos(data.reviews); this.photoPages.set(page,next);
          }
          if (!next.length) { if (direction > 0) this.lastPhotoPage=this.photoPage; this.showPhoto(); return; }
          if (!this.viewer.open) return;
          this.photoPage=page; this.photoIndex=direction > 0 ? 0 : next.length-1; this.showPhoto();
        } catch(error) { if (error.name !== 'AbortError') this.querySelector('[data-viewer-error]').hidden=false; }
        finally { this.photoLoading=false; this.viewer.removeAttribute('aria-busy'); }
      }
      updateInputs() {
        const rating = Number(this.form.elements.rating.value);
        for (const input of this.form.querySelectorAll('[name="rating"]')) input.nextElementSibling.textContent = Number(input.value) <= rating ? '★' : '☆';
        this.querySelector('[data-character-count]').textContent = `${this.form.elements.body.value.length}/5000`;
      }
      clearPreviews() { for (const url of this.previewUrls || []) URL.revokeObjectURL(url); this.previewUrls = []; }
      previewPhotos() {
        this.clearPreviews();
        const preview = this.querySelector('[data-upload-preview]'); preview.replaceChildren();
        const files = [...this.form.elements.photos.files];
        this.querySelector('[data-photo-count]').textContent = `${files.length}/3`;
        const invalid = files.length > 3 || files.some(file => file.size > 5 * 1024 * 1024 || !['image/jpeg','image/png','image/webp'].includes(file.type));
        this.form.elements.photos.setCustomValidity(invalid ? this.labels.photo_limit : '');
        if (invalid) { this.form.elements.photos.reportValidity(); return; }
        for (const file of files) {
          const img = this.node('img'); img.src = URL.createObjectURL(file); this.previewUrls.push(img.src); img.alt = this.labels.photo; preview.append(img);
        }
      }
      stars(value) {
        const stars = this.node('span', '★★★★★'); stars.className = 'ew-review-stars';
        stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', `${Number(value).toFixed(1)} / 5`);
        const fill = this.node('span', '★★★★★'); fill.setAttribute('aria-hidden', 'true');
        stars.style.setProperty('--fill', `${Math.max(0, Math.min(5, Number(value) || 0)) * 20}%`); stars.append(fill); return stars;
      }
      node(tag, text) { const node = document.createElement(tag); if (text != null) node.textContent = text; return node; }
      async load(page, focus = false) {
        this.controller?.abort();
        this.controller = new AbortController();
        this.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(this.dataset.endpoint, location.origin);
          url.searchParams.set('product_id', this.dataset.productId);
          url.searchParams.set('page', page);
          const response = await fetch(url, { signal:this.controller.signal, headers:{ Accept:'application/json' } });
          if (!response.ok) throw new Error('Unavailable');
          const data = await response.json();
          if (!Array.isArray(data.reviews) || data.reviews.length > 5 || !Number.isInteger(data.total) || data.total < 0 ||
              !Number.isInteger(data.pages) || data.pages < 1 || !Number.isInteger(data.page) || data.page < 1 ||
              data.page > data.pages || !Number.isFinite(data.average) || data.average < 0 || data.average > 5) throw new Error('Invalid response');
          this.submissionToken = data.submissionToken;
          this.acceptingSubmissions = data.acceptingSubmissions === true;
          this.render(data);
          this.querySelector('[data-error]').hidden = true;
          this.form.querySelector('[type="submit"]').disabled = data.acceptingSubmissions !== true;
          if (focus) this.querySelector('h2').focus();
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.acceptingSubmissions = false;
          this.querySelector('[data-error]').hidden = false;
          this.form.querySelector('[type="submit"]').disabled = true;
        } finally { this.removeAttribute('aria-busy'); }
      }
      render(data) {
        this.photoPages.set(data.page,this.collectPhotos(data.reviews));
        this.lastPhotoPage=data.pages;
        let photoIndex=0;
        this.classList.toggle('is-empty', data.total === 0);
        const summary = this.querySelector('[data-summary]');
        summary.replaceChildren();
        const average = this.node('strong', data.total ? Number(data.average).toFixed(1) : '—'); average.className = 'ew-review-average';
        const total = this.node('p', data.total ? `${data.total} ${this.labels.reviews}` : this.labels.empty); total.className = 'ew-review-total';
        summary.append(average, this.stars(data.average), total);
        const breakdown = this.querySelector('[data-breakdown]'); breakdown.replaceChildren();
        for (let rating = 5; rating >= 1; rating--) {
          const count = Math.max(0, Number(data.histogram?.[rating - 1]) || 0);
          const row = this.node('div'); row.className = 'ew-review-bar-row';
          const bar = this.node('span'); bar.className = 'ew-review-bar'; bar.setAttribute('aria-hidden', 'true');
          const fill = this.node('span'); fill.style.width = `${data.total ? Math.min(100, count / data.total * 100) : 0}%`; bar.append(fill);
          row.append(this.node('span', `${rating} ${this.labels.star}`), bar, this.node('span', String(count))); breakdown.append(row);
        }
        const gallery = this.querySelector('[data-gallery]');
        if (data.page === 1) gallery.replaceChildren();
        const list = this.querySelector('[data-list]');
        list.replaceChildren();
        for (const review of data.reviews) {
          const article = this.node('article');
          const rating = Math.min(5, Math.max(1, Math.round(Number(review.rating)) || 1));
          article.append(this.stars(rating));
          const person = this.node('div'); person.className = 'ew-review-person';
          const initials = String(review.name || '').trim().split(/\s+/).slice(0,2).map(part => Array.from(part)[0] || '').join('').toUpperCase();
          const avatar = this.node('span', initials); avatar.className = 'ew-review-avatar'; avatar.setAttribute('aria-hidden', 'true');
          const identity = this.node('div'); identity.append(this.node('strong', review.name));
          if (review.verifiedPurchase === true) {
            const check = this.node('span', '✓'); check.className = 'ew-review-check'; avatar.append(check);
            const verified = this.node('span', this.labels.verified); verified.dataset.verified = ''; identity.append(verified);
          }
          person.append(avatar, identity); article.append(person);
          const body = this.node('p', review.body); body.dataset.body = ''; article.append(body);
          const photos = this.node('div'); photos.dataset.photos = '';
          for (const photo of (review.photos || []).slice(0, 3)) {
            let url;
            try { url = new URL(photo.url, location.origin); } catch { continue; }
            if (url.origin !== location.origin || !url.pathname.startsWith('/apps/ethnicwish-reviews/photos/')) continue;
            const link = this.node('a'); link.href = url.href; link.dataset.reviewPhoto = photoIndex++; link.dataset.photoPage = data.page; link.setAttribute('aria-haspopup','dialog');
            const img = this.node('img'); img.src = url.href; img.alt = this.labels.photo; img.width = 90; img.height = 112; img.loading = 'lazy';
            link.append(img); photos.append(link);
            if (data.page === 1 && gallery.children.length < 4) gallery.append(link.cloneNode(true));
          }
          article.append(photos); list.append(article);
        }
        gallery.hidden = gallery.children.length === 0;
        const nav = this.querySelector('[data-pages]'); nav.replaceChildren();
        const pages = Math.max(1, Number(data.pages) || 1);
        const visible = new Set([1, pages]);
        for (let n = Math.max(1, data.page - 2); n <= Math.min(pages, data.page + 2); n++) visible.add(n);
        if (pages > 1) for (const n of [...visible].sort((a,b) => a-b)) {
          const button = this.node('button', String(n)); button.type = 'button'; button.dataset.page = n;
          button.setAttribute('aria-label', `${this.labels.page} ${n}`);
          if (n === data.page) button.setAttribute('aria-current', 'page');
          nav.append(button);
        }
        const title = document.querySelector('.ew-pdp-info h1');
        if (title && !document.querySelector('[data-ew-native-review-summary]')) {
          const badge = this.node('a'); badge.dataset.ewNativeReviewSummary = this.dataset.productId;
          badge.hidden = true; title.after(badge);
        }
        for (const badge of document.querySelectorAll('[data-ew-native-review-summary]')) {
          if (badge.dataset.ewNativeReviewSummary !== this.dataset.productId) continue;
          badge.hidden = data.total === 0; badge.href = `#${this.id}`;
          badge.replaceChildren(this.stars(data.average), this.node('span', `${data.total} ${this.labels.reviews}`));
        }
        this.dispatchEvent(new CustomEvent('ethnicwish:reviews', { bubbles:true, detail:{ productId:this.dataset.productId, average:data.average, total:data.total, sectionId:this.id } }));
      }
      async submit(event) {
        event.preventDefault();
        const status = this.querySelector('[data-form-status]');
        const files = this.form.elements.photos.files;
        if (files.length > 3 || [...files].some(file => file.size > 5 * 1024 * 1024 || !['image/jpeg','image/png','image/webp'].includes(file.type))) {
          status.textContent = this.labels.photo_limit; return;
        }
        const button = this.form.querySelector('[type="submit"]'); button.disabled = true; status.textContent = '';
        const body = new FormData(this.form); body.set('product_id', this.dataset.productId); body.set('submissionToken', this.submissionToken || '');
        try {
          const response = await fetch(this.dataset.endpoint, { method:'POST', body, headers:{ Accept:'application/json' } });
          const data = await response.json();
          if (response.status !== 202 || data.status !== 'pending') throw new Error('Not accepted');
          this.form.reset(); this.updateInputs(); this.previewPhotos(); status.textContent = this.labels.thanks; status.focus(); await this.load(1);
        } catch { status.textContent = this.labels.failed; }
        finally { button.disabled = !this.acceptingSubmissions; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
